import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import ArrowIcon from "../assets/images/arrow-right.svg";
import HeadingLines from "../assets/images/heading-lines.svg";

import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../features/blog/blogActions";
import { stripHtmlTags, truncateText } from "../helpers/helpers";

function HomeBlog({ blogCategoryId }) {
  const [allBlogs, setAllBlogs] = useState([]);

  const dispatch = useDispatch();
  const { blogs } = useSelector((state) => state.blog);

  useEffect(() => {
    const categoryId = blogCategoryId || "";
    const data = { page: 1, limit: 3, blog_category_id: categoryId };
    dispatch(fetchBlogs(data));
  }, [dispatch, blogCategoryId]);

  useEffect(() => {
    if (blogs?.data) {
      setAllBlogs(blogs.data);
    }
  }, [blogs]);

  return (
    <>
      <section className="home-blog">
        <Container>
          <Row>
            <Col md="12">
              <div className="common-header">
                <img src={HeadingLines} alt="" />
                <h2>Latest Blogs From Personal Care</h2>
              </div>
            </Col>

            {allBlogs.map((blog) => (
              <Col sm="12" md="4" className="mb-4 mb-md-0" key={blog.id}>
                <div className="home-blog-box">
                  <img
                    className="home-blog-img"
                    src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${blog.image}`}
                    alt={blog.title}
                  />
                  <div className="home-blog-box-text">
                  <Link
                      to={`/blog-details/${blog.slug}`}
                     
                    >
                    <h2>{blog.title}</h2>
                    </Link>
                    <p>{truncateText(stripHtmlTags(blog.description), 100)}</p>
                    <Link
                      to={`/blog-details/${blog.slug}`}
                      title="Read More"
                      className="custom-bttn"
                    >
                      {" "}
                      Read More{" "}
                      <img className="arrow-icon-img" src={ArrowIcon} alt="" />
                    </Link>
                  </div>
                </div>
              </Col>
            ))}

            <Col md="12">
              <Link
                to="/blogs"
                title="See All Blogs"
                className="custom-bttn btn-center"
              >
                See All Blogs
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default HomeBlog;
